import { useEffect, useState } from "react";
import moment from "moment";

export const useCountdown = (startTime) => {
  const [timeLeft, setTimeLeft] = useState("");

  useEffect(() => {
    if (!startTime) return;

    const interval = setInterval(() => {
      const now = moment();
      const start = moment.utc(Number(startTime)); // Ensure it's treated as ms
      const duration = moment.duration(start.diff(now));

      if (duration.asMilliseconds() <= 0) {
        setTimeLeft("Time reached!");
        clearInterval(interval);
      } else {
        const days = Math.floor(duration.asDays());
        const hours = duration.hours();
        const minutes = duration.minutes();
        const seconds = duration.seconds();

        const formatted = `${days}d ${hours}h ${minutes}m ${seconds}s`;
        setTimeLeft(formatted);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [startTime]);

  return timeLeft;
};
